import React from "react";
import { useTrackButtonClick } from "../../hooks/useTrackButtonClick";

type TrackedButtonProps = {
  actionName: string;

  trackingMetadata?: Record<string, any>;
  onClick: () => void | Promise<void>;
  children: React.ReactElement;
};

export default function TrackedButton({
  actionName,
  trackingMetadata = {},
  onClick,
  children,
}: TrackedButtonProps) {
  const trackButtonClick = useTrackButtonClick();

  const handleClick = async () => {
    try {
      trackButtonClick(actionName, trackingMetadata);
      await onClick();
    } catch (error) {
      console.error("Error in tracked button click:", error);
    }
  };

  return React.cloneElement(children, {
    onClick: handleClick,
  });
}
